import { Components, Theme } from '@mui/material/styles';

export const MuiAppBar: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--palette-background-paper)',
      color: 'var(--palette-text-primary)',
      borderBottom: '1px solid var(--palette-divider)',
    },
  },
};
